import { render, staticRenderFns } from "./Auszeit.vue?vue&type=template&id=60f14888&scoped=true"
import script from "./Auszeit.vue?vue&type=script&lang=js"
export * from "./Auszeit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f14888",
  null
  
)

export default component.exports